import { ProcessedStatus } from 'app/models/import/processedStatus'

export const getProcessedStatus = (status): ProcessedStatus => {
  let processedStatus = ProcessedStatus.None

  switch (status) {
    case 0:
      processedStatus = ProcessedStatus.All
      break
    case 1:
      processedStatus = ProcessedStatus.Some
      break
  }

  return processedStatus
}
